import React from 'react';

function CountryInfo({ countryData }) {
    return (
        <div className="info-section">
            <img src={countryData.flags.svg} alt="Flag" className="flagImage" />
            <h2>{countryData.name.common}</h2>
            <div className="row">
                <div className="dataRow">
                    <h4>Capital:</h4>
                    <span>{countryData.capital ? countryData.capital[0] : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Continent:</h4>
                    <span>{countryData.continents ? countryData.continents[0] : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Population:</h4>
                    <span>{countryData.population ? countryData.population : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Currency:</h4>
                    <span>
                        {countryData.currencies
                            ? `${countryData.currencies[Object.keys(countryData.currencies)[0]].name} - ${Object.keys(countryData.currencies)[0]}`
                            : "N/A"}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Common Languages:</h4>
                    <span>
                        {countryData.languages
                            ? Object.values(countryData.languages).toString().split(',').join(', ')
                            : "N/A"}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Borders:</h4>
                    <span>
                        {countryData.borders
                            ? Object.values(countryData.borders).toString().split(',').join(', ')
                            : "None"}
                    </span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Area:</h4>
                    <span>{countryData.area ? countryData.area : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Calling Area:</h4>
                    <span>{countryData.idd ? `${countryData.idd.root}${countryData.idd.suffixes[0]}` : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>Capital Latitudes and Longitudes:</h4>
                    <span>{countryData.capitalInfo ? `${countryData.capitalInfo.latlng[0]} ${countryData.capitalInfo.latlng[1]}` : "N/A"}</span>
                </div>
            </div>
            <div className="row">
                <div className="dataRow">
                    <h4>TimeZones:</h4>
                    <span>
                        {countryData.timezones ? Object.values(countryData.timezones).toString().split(',').join(', ') : "N/A"}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default CountryInfo;
